import { MatDialogRef } from '@angular/material/dialog';
import { Sc4FailedMessagesListSearchCriteria } from '../../models';
import { ExportDialogComponent } from '../../../../../../ui-kit';

export class Sc4FailedMessagesExportStart {
  public static readonly type = '[Sc4FailedMessagesExport] Start';

  constructor(
    public payload: {
      searchCriteria: Sc4FailedMessagesListSearchCriteria;
      reportName: string;
      dialogRef: MatDialogRef<ExportDialogComponent>;
      navigationNeeded: boolean;
    },
  ) {}
}

export class Sc4FailedMessagesExportSetInitialState {
  public static readonly type = '[Sc4FailedMessagesExport] Set Initial State';
}
